/**
 * 分页独立入口：gulp 打包为 dist/js/daetoolPagination.js
 * 页面通过 script 标签引入后，使用全局 DaetoolPagination / parseDaetoolWebInfo
 */
import DaetoolPagination from './common/daetoolPagination';
import { parseDaetoolWebInfo } from './common/daetoolPagination';
if (typeof window !== 'undefined') {
    window.DaetoolPagination = DaetoolPagination;
    window.parseDaetoolWebInfo = parseDaetoolWebInfo;
}
export default DaetoolPagination;
export { parseDaetoolWebInfo };
